module.exports = __webpack_public_path__ + "assets/images/imc_y.afdb2c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/imc_y.png
// module id = 748
// module chunks = 1